export default status => {
  switch (status) {
    case 'valid':
    case 'active':
    case 'scheduled':
    case 'trialing':
    case 'paid':
    case 'succeeded':
    case 'enabled':
    case 'recovered':
    case 'on_sale':
      return {
        backgroundColor: 'green',
        textColor: 'white',
        className: 'bg-green-300 text-white',
      };
    case 'partially_paid':
    case 'unpaid':
    case 'past_due':
      return {
        backgroundColor: 'orange',
        textColor: 'white',
        className: 'bg-orange-500 text-white',
      };
    case 'canceled':
    case 'failed':
    case 'incomplete_expired':
      return {
        backgroundColor: 'red',
        textColor: 'white',
        className: 'bg-red-500 text-white',
      };
    case 'sold_out':
      return {
        backgroundColor: 'black',
        textColor: 'white',
        className: '!bg-black text-white',
      };
    case 'created':
    case 'incomplete':
    case 'expired':
    case 'deleted':
    case 'test':
    case 'pending':
    case 'refunded':
    case 'archived':
    case 'hidden':
    case 'disabled':
    case 'unavailable':
    case 'sale_ended':
    case 'abandoned':
    default:
      return {
        backgroundColor: 'gray-dark',
        textColor: 'white',
        className: 'bg-gray-500 text-white',
      };
  }
};
